import Clickable from './Clickable'

export default Clickable
